import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { CustomerService } from 'app/back-office/shared/services/back-office/customer.service';
import { PointOfSaleService } from 'app/back-office/shared/services/back-office/pointOfSale.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { RolesEnum } from 'app/shared/enums/roles.enum';
import { SessionStore } from 'app/shared/state/session.store';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-customer-filter',
    templateUrl: './customer-filter.component.html',
    styleUrls: ['./customer-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search customer...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  private _session = inject(SessionStore);
  private _shopContext = inject(ShopContextStore);

  constructor(
    private customerService: CustomerService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    const role = this._session.userInfo().mainRole;

    const agencyId =
      role === RolesEnum.AgencyOwner || role === RolesEnum.Agent
        ? this._session.userInfo().agency.id
        : undefined;

    const storeId =
      role === RolesEnum.Administrator
        ? undefined
        : this._shopContext.currentShop().id;

    this.customerService.getAllCustomers(this.loaderId, {
      searchString: this.searchValue,
      skipCount,
      maxResultCount: 20,
      agencyId,
      sorting: 'name',
      storeId
    }).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.CustomerFilter(el));
      this.totalCount = res.totalCount + 1;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

}
